import { Card, CardContent, CardHeader, CardTitle } from '@gozoki/ui/components/ui/card'

// Affichée quand l'IP publique du device n'est rattachée à aucune boutique (auth store-app par IP).
export function ErrorPage() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-6">
      <Card className="w-full max-w-sm">
        <CardHeader>
          <CardTitle className="text-center text-xl">Lucie — Boutique</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-center text-sm text-muted-foreground">
            Cet appareil n'est pas dans un magasin reconnu.
          </p>
        </CardContent>
      </Card>
    </div>
  )
}
